import { useInView } from 'react-intersection-observer';

export default function ImageCard({ image, onChange }) {
  const { name, url, id } = image;
  const { ref, inView } = useInView({
    triggerOnce: true,
    fallbackInView: true,
  });

  const handleSelectOnClick = () => {
    onChange({ id, url, alt: '', title: '' });
  };

  return (
    <div className="image-card">
      <div className="top-bar">
        <label className="image-name">{name}</label>
      </div>

      <button className="image-container-button" onClick={handleSelectOnClick} data-bs-dismiss="modal">
        <div ref={ref} className="image-container">
          {url ? (
            inView ? (
              <>
                <img src={url} alt={`Image ID: ${id}`} />
                <div className="overlay">
                  <span>Select</span>
                </div>
              </>
            ) : (
              <div className="preview-container">
                <i className="fe fe-file" />
              </div>
            )
          ) : (
            <div className="preview-container">CDN URL is not found.</div>
          )}
        </div>
      </button>
    </div>
  );
}
